import styled, { css } from 'styled-components';
import { layout, media, remCalc } from '@prisjakt/ui-base';
import StoreLogoComponent from '@prisjakt/ui-store-logo';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';
import LocationAndCurrencyInfoComponent from '../../../../components/location-and-currency-info';
import CardComponent from '../card';
import { CONTENT_TITLE_SIZE } from '../../constants';

export const StoreLogo = styled(StoreLogoComponent)`
  margin-bottom: ${layout.measurements.spacing100};
`;

export const LocationAndCurrencyInfo = styled(LocationAndCurrencyInfoComponent)`
  margin-bottom: ${layout.measurements.spacing150};
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  ${media.smallOnly`
    grid-template-columns: 1fr;
  `}
`;

export const StoreInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: ${layout.measurements.spacing150};
  margin-bottom: ${layout.measurements.spacing150};
`;

export const Title = styled.h3`
  font-size: ${remCalc(CONTENT_TITLE_SIZE)};
  margin-bottom: ${layout.measurements.spacing100};
`;

export const Awards = styled.div`
  margin-bottom: ${layout.measurements.spacing100};
`;

export const AuthorizedDealers = styled.div``;

type SotyCardProps = { limit: number };

export const Card = styled(CardComponent)<SotyCardProps>(
  props => css`
    max-width: ${`${100 / props.limit}%`};
    z-index: 1;

    > * {
      margin: ${layout.measurements.spacing050};
    }

    ${media.largeUp`
      &:nth-child(${props.limit}n + 1) {
        > * {
          margin-left: 0;
        }
      }

      &:nth-child(${props.limit}n + ${props.limit}) {
        > * {
          margin-right: 0;
        }
      }
    `}

    ${media.mediumDown`
      max-width: 50%;
      margin-right: auto;

      &:nth-child(2n + 1) {
        > * {
          margin-left: 0;
        }
      }

      &:nth-child(2n + 2) {
        > * {
          margin-right: 0;
        }
      }
    `}

    @media ${'screen and (max-width: 320px)'} {
      max-width: 100%;

      > * {
        margin-left: 0;
        margin-right: 0;
      }
    }
  `
);

export const CheckIcon = styled(CheckCircleIcon)`
  margin-right: ${layout.measurements.spacing050};
`;

export const DeliveryOptionList = styled.ul`
  list-style: none;
`;

export const DeliveryOption = styled.li`
  display: flex;
  align-items: center;
  margin: ${layout.measurements.spacing025} 0;
  color: ${props => props.theme.text.secondary};

  ${CheckIcon} {
    color: ${p => p.theme.colors.positive500};
  }
`;
